import { render, staticRenderFns } from "./modals-jira.vue?vue&type=template&id=43a79016"
import script from "./modals-jira.vue?vue&type=script&lang=js"
export * from "./modals-jira.vue?vue&type=script&lang=js"
import style0 from "./modals-jira.vue?vue&type=style&index=0&id=43a79016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports